import { useParams } from 'react-router';
import React from 'react';
import useClinicMasterProduct from '../../../apis/clinic-master-products/hooks/useClinicMasterProduct';
import { Loading } from '../../../healtheraComponents';
import ModifyClinicMasterProduct from '../components/ModifyClinicMasterProduct/ModifyClinicMasterProduct';
import { useClinicProducts } from '../../../apis/clinic-products/hooks/useClinicProducts';

interface Params {
  clinicMasterProductId: string;
  clinicId: string;
}

const ModifyClinicMasterProductContainer = () => {
  const { clinicMasterProductId: id, clinicId } = useParams<Params>();

  const { clinicMasterProduct, isLoading: isLoadingMasterProduct } = useClinicMasterProduct(id);
  const { clinicProducts, isLoading: isLoadingProducts } = useClinicProducts(clinicMasterProduct?._id);

  const isLoading = isLoadingMasterProduct || isLoadingProducts;

  if (isLoading) {
    return <Loading />;
  }

  if (!clinicMasterProduct) {
    return <div>Clinic master product not found</div>;
  }

  return (
    <ModifyClinicMasterProduct
      clinicProducts={clinicProducts}
      clinicId={clinicId}
      clinicMasterProduct={clinicMasterProduct}
    />
  );
};

export default ModifyClinicMasterProductContainer;
